import UI from 'root/ui';
import Cache from 'root/cache';
import Router from 'root/router';
import Form from 'root/module/form';
import View from 'view/base';
import View_Settings_General from 'view/portal/settings/general';
import View_Settings_Status from 'view/portal/settings/status';
import View_Settings_Branding from 'view/portal/settings/branding';
import View_Settings_Translation from 'view/portal/settings/translation';
import View_Settings_SSO from 'view/portal/settings/sso';
import View_Settings_Import from 'view/portal/settings/import';

export default View.extend({
    className: 'portal-settings project-settings-inner-xlarge',

    views: {
        general: {},
        status: {},
        branding: {},
        translation: {},
        sso: {},
        import: {}
    },

    events: {
        'click .active-toggle' : 'onToggleActive',
        'click .get-started'   : 'onGetStarted'
    },

    dom_handlers: {
        onToggleActive: function(e) {
            if (this.$el.find('.active-toggle').hasClass('switch-on')) {
                this.$el.find('.active-toggle').addClass('switch-off').removeClass('switch-on');
                this.$el.find('.live-toggle').text('Paused');
            } else {
                this.$el.find('.active-toggle').addClass('switch-on').removeClass('switch-off');
                this.$el.find('.live-toggle').text('Live');
            }

            Cache.app.request({
                action: 'portal/update',
                data: {
                    portal_id : this.model.id,
                    is_active : this.$el.find('.active-toggle').hasClass('switch-on')
                },
                context: this,
                success: function(response) {
                    this.model.set('is_active', response.is_active);

                    if (response.is_active) {
                        UI.success('Ideas portal is set ot live');
                    } else {
                        UI.success('Ideas portal is paused');
                    }
                }
            });
        },

        onGetStarted: function(e) {
            e.preventDefault();
            UI.buildPage('portal_settings');
        }
    },

    initialize: function() {
        this.views.general     = new View_Settings_General({model: this.model});
        this.views.status      = new View_Settings_Status({model: this.model});
        this.views.branding    = new View_Settings_Branding({model: this.model});
        this.views.translation = new View_Settings_Translation({model: this.model});
        this.views.sso         = new View_Settings_SSO({model: this.model});
        this.views.import      = new View_Settings_Import({model: this.model});
    },

    render: function() {
        if (!this.model) {
            return this;
        }

        var content =
        '<div class="tab">' +
            '<div class="tab-menu">' +
                '<a href="#" class="active">General</a>' +
                '<a href="#">Status</a>' +
                '<a href="#">Branding</a>' +
                '<a href="#">Single Sign-On</a>' +
                '<a href="#">Translation</a>' +
                '<a href="#">Import</a>' +
            '</div>' +
            '<div class="tab-content">' +
                '<div class="region-settings-general active"></div>' +
                '<div class="region-settings-status"></div>' +
                '<div class="region-settings-branding"></div>' +
                '<div class="region-settings-sso"></div>' +
                '<div class="region-settings-translation"></div>' +
                '<div class="region-settings-import"></div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        Form.setData(this.$el.find('form'), {
            portal_name  : this.model.get('portal_name'),
            categories   : this.model.get('categories').split(',')
        });

        this.views.general.render().$el.appendTo(this.$el.find('.region-settings-general'));
        this.views.status.render().$el.appendTo(this.$el.find('.region-settings-status'));
        this.views.branding.render().$el.appendTo(this.$el.find('.region-settings-branding'));
        this.views.translation.render().$el.appendTo(this.$el.find('.region-settings-translation'));
        this.views.sso.render().$el.appendTo(this.$el.find('.region-settings-sso'));
        this.views.import.render().$el.appendTo(this.$el.find('.region-settings-import'));

        return this;
    }
});